import { useState, useEffect } from "react";

const sortOptions = [
  { label: "Recently Created", value: "recently_created" },
  { label: "Ending Soon", value: "ending_soon" },
  { label: "Alphabetical A-Z", value: "alphabetical_a_z" },
  { label: "Alphabetical Z-A", value: "alphabetical_z_a" },
];

const CampaignsSortFilter = ({
  onSortChange,
  currentSort = "recently_created",
}) => {
  const [selectedOption, setSelectedOption] = useState(
    sortOptions.find((option) => option.value === currentSort) ||
      sortOptions[0],
  );
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);

  useEffect(() => {
    const option = sortOptions.find((option) => option.value === currentSort);
    if (option) {
      setSelectedOption(option);
    }
  }, [currentSort]);

  const handleOptionSelect = (option) => {
    setSelectedOption(option);
    setIsDropdownOpen(false);
    onSortChange(option.value);
  };

  const toggleDropdown = () => {
    setIsDropdownOpen(!isDropdownOpen);
  };

  return (
    <div className="relative w-full">
      <div
        className="inline-flex w-full sm:min-w-48 items-center justify-between rounded-lg border border-jacarta-100 dark:border-jacarta-600 bg-white dark:bg-jacarta-700 h-10 sm:h-12 py-2 sm:py-3 px-3 sm:px-4 hover:border-accent dark:hover:border-accent transition-all duration-200 cursor-pointer"
        onClick={toggleDropdown}
      >
        <span className="text-sm sm:text-base text-jacarta-700 dark:text-jacarta-300 font-medium truncate">
          {selectedOption.label}
        </span>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 24 24"
          width={20}
          height={20}
          className={`h-4 w-4 sm:h-5 sm:w-5 fill-jacarta-500 dark:fill-jacarta-400 transition-transform duration-200 flex-shrink-0 ml-2 ${
            isDropdownOpen ? "rotate-180" : ""
          }`}
        >
          <path fill="none" d="M0 0h24v24H0z" />
          <path d="M12 13.172l4.95-4.95 1.414 1.414L12 16 5.636 9.636 7.05 8.222z" />
        </svg>
      </div>

      {/* Dropdown Menu */}
      {isDropdownOpen && (
        <div className="absolute top-full left-0 z-50 w-full sm:min-w-48 mt-2 whitespace-nowrap rounded-xl bg-white dark:bg-jacarta-800 py-2 text-left shadow-xl border border-jacarta-100 dark:border-jacarta-600">
          {sortOptions.map((option) => (
            <button
              key={option.value}
              className={`flex w-full items-center justify-between rounded-lg mx-1 sm:mx-2 px-2 sm:px-3 py-2 sm:py-2.5 text-left text-sm transition-colors ${
                selectedOption.value === option.value
                  ? "bg-accent/10 dark:bg-accent/20 text-accent dark:text-accent"
                  : "text-jacarta-700 dark:text-jacarta-300 hover:bg-jacarta-50 dark:hover:bg-jacarta-700"
              } ${selectedOption.value === option.value && "font-semibold"}`}
              onClick={() => handleOptionSelect(option)}
            >
              <span className="truncate">{option.label}</span>
              {selectedOption.value === option.value && (
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 24 24"
                  width={20}
                  height={20}
                  className="h-4 w-4 fill-accent dark:fill-accent flex-shrink-0"
                >
                  <path fill="none" d="M0 0h24v24H0z" />
                  <path d="M10 15.172l9.192-9.193 1.415 1.414L10 18l-6.364-6.364 1.414-1.414z" />
                </svg>
              )}
            </button>
          ))}
        </div>
      )}

      {/* Click outside to close */}
      {isDropdownOpen && (
        <div
          className="fixed inset-0 z-40"
          onClick={() => setIsDropdownOpen(false)}
        />
      )}
    </div>
  );
};

export default CampaignsSortFilter;
